import round10Decimals from "./round10Decimals";

/*
  Tope de un renglon en las pantallas de Apartar / Entregar / Desapartar: lo que
  falta por mover del documento, acotado por el inventario del proyecto.

  NUNCA regresa NaN. Es la razon de existir de este helper: la prop `max` de
  FormItem se traduce a una regla de antd con `if (this.props.max || this.props.max === 0)`,
  y NaN es falsy con NaN === 0 en false, asi que un max NaN hace DESAPARECER la
  regla y deja el campo SIN TOPE. Las 8 pantallas calculaban
  `Math.min(cantidad - movido, cantidadProyecto)` sin guardas, de modo que un
  `cantidadProyecto` undefined (el bulk de inventario fallo) producia "Max: NaN"
  y un renglon que aceptaba cualquier cantidad.

  cantidadProyecto === "No inventariable" -> sin tope de inventario.
  cantidadProyecto desconocido (undefined / null / no numerico) -> tampoco se
    inventa un tope: queda solo el tope del documento. El llamador DEBE avisar
    del fallo de carga, porque en ese estado el front no puede validar el
    inventario y solo lo valida el backend.
*/
const calcularMaxDisponible = ({ cantidad, yaMovido = 0, cantidadProyecto }) => {
  const cantidadNum = Number(cantidad);
  const yaMovidoNum = Number(yaMovido);
  const maxDocumento = Number.isFinite(cantidadNum)
    ? Math.max(
        0,
        round10Decimals(cantidadNum - (Number.isFinite(yaMovidoNum) ? yaMovidoNum : 0))
      )
    : 0;

  let maxProyecto;
  if (cantidadProyecto === "No inventariable") {
    maxProyecto = Infinity;
  } else if (
    // null / undefined / "" son "no se pudo leer", NO "cero disponible": hay que
    // descartarlos ANTES del Number(), porque Number(null) y Number("") dan 0 y
    // dejarian el renglon topado en 0 sin que exista tal restriccion.
    cantidadProyecto === null ||
    cantidadProyecto === undefined ||
    cantidadProyecto === ""
  ) {
    maxProyecto = Infinity;
  } else {
    const proyectoNum = Number(cantidadProyecto);
    maxProyecto = Number.isFinite(proyectoNum) ? Math.max(0, proyectoNum) : Infinity;
  }

  return Math.min(maxDocumento, maxProyecto);
};

export default calcularMaxDisponible;
